/**
 * ESCHER FALLS — 漢数字。版画らしさのため、ステージ番号にだけ使う。
 * `hud.ts` と `stageSelect.ts` が共有する。
 */

import { LANG } from './i18n';

const KANJI_DIGITS = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九'] as const;

/** 1〜99 を漢数字にする。範囲外・非整数はそのまま算用数字で返す。 */
export function toKanjiNumber(n: number): string {
  if (!Number.isInteger(n) || n < 0 || n > 99) return String(n);
  if (n < 10) return KANJI_DIGITS[n];
  const tens = Math.floor(n / 10);
  const ones = n % 10;
  const head = tens === 1 ? '十' : `${KANJI_DIGITS[tens]}十`;
  return ones === 0 ? head : head + KANJI_DIGITS[ones];
}

/**
 * ステージ番号の表示。
 *
 * 漢数字は版画らしさのために選んだ書体上の意匠だが、**読めない人には
 * ただの記号になる。** 日本語のときだけ漢数字、それ以外は算用数字。
 */
export function stageNumber(n: number): string {
  return LANG === 'ja' ? toKanjiNumber(n) : String(n);
}
